import React, { useContext,useState } from "react";
import { Col, Row, Form, Button, Spinner, FormGroup } from "react-bootstrap";
const Loader = (props) => {
    console.log('props',props);
    const showText = true;

    
  return (
    <>
        <div className={`${showText ? 'bg-text': 'd-none' }`}>
            <div className="loading">
            <Spinner
                as="span"
                animation="border"
                variant="primary"
                role="status"
                aria-hidden="true"                      
            />
            <p>Please wait a moment while we process your request.</p>
                            
            </div>
        
        </div>
    </>
  );
};

export default Loader;
